// Extrait du Dashboard Finance — bloc des 6 KPIs du haut.
// Données : /api/metier/stats/visites-amo
import {
  Receipt, TrendingUp, TrendingDown, Clock, Euro, Eye,
  Loader2,
} from "lucide-react";
import { useFinanceFetch, formatEuro } from "./useFinanceFetch";

function KpiCard({ title, value, icon: Icon, accent, subtitle }) {
  return (
    <div
      className="rounded-xl p-4"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid={`finance-kpi-${title.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs mb-1" style={{ color: "var(--oh-text-muted)" }}>{title}</p>
          <p className="text-2xl font-bold truncate" style={{ color: "var(--oh-text)" }}>{value}</p>
          {subtitle && (
            <p className="text-[11px] mt-1 truncate" style={{ color: "var(--oh-text-secondary)" }}>{subtitle}</p>
          )}
        </div>
        <div className="p-2 rounded-lg shrink-0" style={{ backgroundColor: `${accent}20` }}>
          <Icon className="w-4 h-4" style={{ color: accent }} />
        </div>
      </div>
    </div>
  );
}

export default function FinanceKpisWidget() {
  const { data, loading, error } = useFinanceFetch("/api/metier/stats/visites-amo");

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur chargement KPIs Finance : {error}
      </div>
    );
  }

  const s = data?.stats || {};
  const visiteurs = data?.par_visiteur?.length || 0;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="finance-kpis-widget">
      <KpiCard
        title="Factures AMO" value={s.avec_facture || 0} icon={Receipt}
        accent="var(--oh-stat-blue-text)"
        subtitle={`${formatEuro(s.montant_total_amo || 0)} AMO`}
      />
      <KpiCard
        title="Encaissements" value={s.avec_reglement || 0} icon={TrendingUp}
        accent="#10b981"
        subtitle="Règlements clients reçus"
      />
      <KpiCard
        title="Décaissements" value={s.visites_payees || 0} icon={TrendingDown}
        accent="var(--oh-stat-red-text)"
        subtitle={`${s.visites_non_payees || 0} visites non payées`}
      />
      <KpiCard
        title="Visites à payer" value={s.visites_non_payees || 0} icon={Clock}
        accent="var(--oh-stat-amber-text)"
        subtitle="Visiteurs en attente"
      />
      <KpiCard
        title="CA AMO" value={formatEuro(s.montant_total_amo || 0, { compact: true })} icon={Euro}
        accent="#8b5cf6"
        subtitle="Honoraires AMO"
      />
      <KpiCard
        title="Visites total" value={s.avec_visite || 0} icon={Eye}
        accent="var(--oh-stat-cyan-text)"
        subtitle={`${visiteurs} visiteur${visiteurs > 1 ? "s" : ""}`}
      />
    </div>
  );
}
